export function AppIcon({ className = "w-10 h-10", variant = "light" }: { className?: string, variant?: "light" | "dark" }) {
  // Gold color from the logo
  const goldColor = "#C9A861"
  const bgColor = variant === "dark" ? "#2D2D2D" : "#FDFBF7"

  return (
    <div
      className={`${className} rounded-xl flex items-center justify-center`}
      style={{ backgroundColor: bgColor }}
    >
      <svg
        viewBox="0 0 48 48"
        fill="none"
        className="w-[75%] h-[75%]"
      >
        {/* Arched frame - outer */}
        <path
          d="M10 44V20C10 12.268 16.268 6 24 6C31.732 6 38 12.268 38 20V44"
          stroke={goldColor}
          strokeWidth="1.5"
          fill="none"
        />
        {/* Arched frame - inner */}
        <path
          d="M13 44V20C13 13.925 17.925 9 24 9C30.075 9 35 13.925 35 20V44"
          stroke={goldColor}
          strokeWidth="1.5"
          fill="none"
        />
        {/* Center vertical line */}
        <line x1="24" y1="12" x2="24" y2="44" stroke={goldColor} strokeWidth="1.5" />
        {/* Small hanger oval at top */}
        <ellipse cx="24" cy="14" rx="1.5" ry="2.5" stroke={goldColor} strokeWidth="1.5" fill="none" />
        {/* w letter - elegant curved */}
        <path
          d="M16 28C16 28 17.5 38 19 38C20.5 38 22 32 22 32C22 32 23.5 38 24 38"
          stroke={goldColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* K letter */}
        <path
          d="M26 28V40"
          stroke={goldColor}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M26 34L32 28"
          stroke={goldColor}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M28 35.5L32 40"
          stroke={goldColor}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  )
}
